import { useEffect, useState } from "react";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../core/services/Singleton";
import { ListMenu } from "../../theme/Component/ListMenu";
import { BasicPage } from "../../theme/Component/BasicPage";
import { BasicTable, MASK_DATE } from "../../theme/Component/BasicTable";
import { Modal } from "../../theme/Component/Modal";
import { ModalConfirm } from "../../theme/Component/ModalConfirm";
import { _PriceList, _PriceListItem } from "../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../core/services/dataBean/EntityCatalog";
import { SelectStoreEditor } from "../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { SelectProductEditor } from "../ManufacturingStandars/Components/SelectProductEditor";
import { toast } from "react-toastify";
import usePaginator from "../../theme/Component/usePaginator";
import { BasicButton } from "../../theme/Component/BasicButton";
import { CurrencyEditor } from "../../erp/cellEditor/Currency/CurrencyEditor";

type filters = {
    IDStore: number
    IDProduct: number
    regexSTR: string
}

interface Props {
    IDPriceList: number;
}

export const PriceListItem = ({ IDPriceList }: Props) => {

    const { instance, bean, setBean, lista, setLista, deleteItemVoid } = useDataBean(_PriceListItem);
    const paginador = usePaginator();

    const [filter, setFilter] = useState<Partial<filters>>({});

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [IDPriceList])

    const getLista = () => {
        instance.getPriceListItemCatalog(IDPriceList, filter.IDProduct, filter.IDStore, filter.regexSTR, paginador.page, 15).then(
            (resp: any) => {
                paginador.setPages(resp.NumberOfPages);
                paginador.setRecords(resp.NumberOfPages * (15));
                paginador.setRegiPerPage(15);
                // setLista(resp.List);
                let x = resp.List;
                x.forEach((user) => {
                    user.DataBeanProperties.Money = (user.DataBeanProperties.CurrencyCode ?? "") + "-" + (user.DataBeanProperties.CurrencyName ?? "");
                });
                setLista(x)
            }
        ).catch((err) => {
            console.log(err)
            toast.error(err)
        })

    }

    const create = () => {
        setBean({
            IDStore: filter.IDStore
        });
        setModal({ ...modal, "view": true, name: "Agregar Precio de Producto" });
    }
    const deleteItem = () => {
        deleteItemVoid(bean.IDPriceList).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }

    const addPriceListItem = () => {

        instance.addPriceListItem(IDPriceList, bean.IDProduct, bean.IDStore, bean.PriceValue, bean.CostValue).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    getLista()
                    setModal({ ...modal, "view": false });
                }
            }
        ).catch((err) => {
            toast.error("No se pudo realizar la acción")
            console.log(err)
        })
    }

    const head = [
        { title: 'ID', property: 'IDPriceListItem', visible: true },
        { title: 'Producto', property: 'ProductDescription', visible: true },
        { title: 'Referencia', property: 'ProductReference', visible: true, MASK_DATE },
        { title: 'Código', property: 'ProductProductCode', visible: true },
        { title: 'Almacén', property: 'StoreName', visible: true },
        { title: 'Moneda', property: 'Money', visible: true },
        { title: 'Precio de Venta', property: 'PriceValue', visible: true },
        { title: 'Costo de Venta', property: 'CostValue', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="col-md-6">
                <SelectStoreEditor idSelector={filter.IDStore} onChange={(e: any) => { setFilter({ ...filter, IDStore: e.IDStore }) }} label="Almacen" />
            </div>
            <div className="col-md-6">
                <SelectProductEditor onChange={(e) => { setFilter({ ...filter, IDProduct: e.IDProduct }) }} label="Producto" />
            </div>
            <div className="col-md-6">
                <label>Búsqueda por Texto</label>
                <input type="text" className="form-control" value={filter.regexSTR} onChange={(e) => { setFilter({ ...filter, regexSTR: e.target.value }) }} />
            </div>
            <div className="col-md-3">
                <BasicButton useMargin eventClick={() => { getLista() }} icon="ri-search-line" children={`Buscar`} />
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={addPriceListItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <CurrencyEditor id={bean.CurrencyType} onchange={(e: any) => { setBean({ ...bean, "CurrencyType": e }) }}></CurrencyEditor>
                        </div>
                        <div className="col-md-6">
                            <SelectStoreEditor label="Almacén" idSelector={bean.IDStore} onChange={(e) => { setBean({ ...bean, "IDStore": e.IDStore }) }} />
                        </div>
                        <div className="col-md-6">
                            <SelectProductEditor label="Producto" value={bean.IDProduct} onChange={(e) => { setBean({ ...bean, "IDProduct": e.IDProduct }); console.log(e) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Precio de Venta</label>
                            <input type="text" name="PriceValue" className="form-control" value={bean.PriceValue} onChange={(e) => { setBean({ ...bean, "PriceValue": parseFloat(e.target.value) }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Costo de Venta</label>
                            <input type="text" name="CostValue" className="form-control" value={bean.CostValue} onChange={(e) => { setBean({ ...bean, "CostValue": parseFloat(e.target.value) }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}